/** Shared presentation for uncommitted placement/copy geometry. No model state. */
const color = '#f59d13', colorNumber = Number.parseInt(color.slice(1),16), fillOpacity = 0.2;
const rgb = [colorNumber >> 16, (colorNumber >> 8) & 255, colorNumber & 255];
export const GHOST_STYLE = Object.freeze({
  color, colorNumber,
  opacity: 0.62, fillOpacity, strokeOpacity: 0.92,
  strokeWidth: 2, dash: '14 10', fill: `rgba(${rgb.join(", ")}, ${fillOpacity})`
});

export function ghostSvgAttributes() {
  return {fill:GHOST_STYLE.color, 'fill-opacity':GHOST_STYLE.fillOpacity,
    stroke:GHOST_STYLE.color, 'stroke-opacity':GHOST_STYLE.strokeOpacity,
    'stroke-width':GHOST_STYLE.strokeWidth, 'stroke-dasharray':GHOST_STYLE.dash,
    opacity:GHOST_STYLE.opacity, 'pointer-events':'none', 'data-plan-ghost':'true'};
}

function inheritedPaint(element, paint, layer) {
  for (let node=element; node && node!==layer.parentNode; node=node.parentNode) {
    const value=String(node.style?.getPropertyValue(paint)||node.getAttribute?.(paint)||'').trim().toLowerCase();
    if (value && value!=='inherit') return value;
  }
  return '';
}

/** Tint a detached preview only. Preserve holes, masks, white CAD faces and text. */
export function applyGhostStyle(layer) {
  if (!layer?.querySelectorAll) return;
  layer.setAttribute('data-plan-ghost','true');
  layer.setAttribute('opacity',String(GHOST_STYLE.opacity));
  layer.setAttribute('pointer-events','none');
  for (const child of layer.querySelectorAll('[data-plan-ghost]')) child.setAttribute('opacity','1');
  for (const element of layer.querySelectorAll('path,polygon,polyline,rect,circle,ellipse,line,use')) {
    if (element.closest?.('defs,clipPath,mask,[data-placement-valid="false"],.is-invalid')) continue;
    for (const paint of ['fill','stroke']) {
      const value=inheritedPaint(element,paint,layer);
      if (!value || value==='none' || value==='transparent' || value.startsWith('url(')) continue;
      if (paint==='fill' && ['white','#fff','#ffffff'].includes(value)) continue;
      element.setAttribute(paint,GHOST_STYLE.color);
      element.style?.removeProperty(paint);
      const opacity=paint==='fill'?GHOST_STYLE.fillOpacity:GHOST_STYLE.strokeOpacity;
      element.setAttribute(`${paint}-opacity`,String(opacity));
      element.style?.removeProperty(`${paint}-opacity`);
    }
  }
}

export const GHOST_CSS = `--plan-ghost-color:${GHOST_STYLE.color};--plan-ghost-fill:${GHOST_STYLE.fill};--plan-ghost-opacity:${GHOST_STYLE.opacity};--plan-ghost-width:${GHOST_STYLE.strokeWidth};--plan-ghost-dash:${GHOST_STYLE.dash};`;
